import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const DashboardService = {
  actions: {
    fetchTotalCounts ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/dashboard/counts',
          method: 'GET'
        })
          .then(resp => {
            const counts = resp.data.counts
            commit('api_success')
            resolve(resp)
            return counts
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchTopProducts ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/dashboard/top_products',
          method: 'GET'
        })
          .then(resp => {
            const topProducts = resp.data.top_products
            commit('api_success')
            resolve(resp)
            return topProducts
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchTopAccounts ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/dashboard/top_accounts',
          method: 'GET'
        })
          .then(resp => {
            const topAccounts = resp.data.top_accounts
            commit('api_success')
            resolve(resp)
            return topAccounts
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchActivity ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/dashboard/activity',
          method: 'GET'
        })
          .then(resp => {
            const activity = resp.data.activity
            commit('api_success')
            resolve(resp)
            return activity
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  }
}

export default DashboardService



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.module.js